import React from "react";
import './termsconditions.css';

function MCTermsConditions() {
    return (
        <div className="mc-terms-page">

            <p className="mc-terms-brand">VODAFONE FIJI</p>
            <p className="mc-terms-product">M-PAiSA Mastercard</p>
            <p className="mc-terms-title"><strong>Terms &amp; Conditions</strong></p>
            <p className="mc-terms-version"><strong>Version: 23rd June 2026</strong></p>


            <h1 id="introduction">INTRODUCTION</h1>
            <h1 className="unnumbered" id="section"></h1>
            <p><strong>1.1 Application of these Terms and
                Conditions</strong></p>
            <p>The following Terms and Conditions (T&amp;Cs) comprise the agreement
                between Vodafone Fiji Pte Limited (Vodafone Fiji) and You, as a holder
                of a M-PAiSA Mastercard.</p>
            <p>The T&amp;Cs will direct the terms under which You may have access to
                and use the M-PAiSA Mastercard. The T&amp;Cs must be read in conjunction
                and will apply together with the M-PAiSA Conditions of Use (can be found
                on the Vodafone Fiji website: www.vodafone. com.fj). Please read these
                carefully before activating the M-PAiSA Mastercard.</p>
            <p>These T&amp;Cs may be terminated by You or Vodafone Fiji for the
                reasons as may be stated in these T&amp;Cs, save for those provisions
                that are stated to survive.</p>
            <p><strong>1.2 Your Acceptance of these Terms and
                Conditions</strong></p>
            <p>Before Your M-PAiSA Mastercard is activated, You must accept and
                agree to be legally bound by these T&amp;Cs including the applicable
                M-PAiSA Mastercard Fees and Charges. Your agreement will be recorded,
                and these T &amp; Cs shall be effective, valid and binding when You
                click the acceptance of T&amp;Cs option on the M-PAiSA App and complete
                the electronic signature, or when You physically/electronically sign
                acceptance at a Vodafone Fiji retail store.</p>
            <p>If You do not understand the T&amp;Cs, You should not click the
                acceptance option on the M-PAiSA App, physically/electronically sign
                Your acceptance or, access or use the M-PAiSA Mastercard.</p>
            <p>If you are issued a virtual or physical M-PAiSA Mastercard and no
                longer wish to use the service, you may visit any Vodafone premium
                outlet to deactivate and retire your card. Until you return and retire
                Your Mastercard, You will continue to incur and be liable for the
                monthly service access fee.</p>
            <p><strong>1.3 M-PAiSA Mastercard</strong></p>
            <p>With M-PAiSA Mastercard You can pay for goods and services locally
                and internationally where payment through Mastercard is accepted, just
                like a bank issued debit card. You can also conduct ecommerce
                transactions like pay for goods and services online and make payment to
                overseas merchants who accept Mastercard payment.</p>
            <p>Application for M-PAiSA Mastercard can be made digitally using the
                M-PAiSA App. There is no paper-based application. All registration
                details must be uploaded electronically.</p>
            <p>You may have applied for and received a physical card, virtual card
                or a digital card.</p>
            <p>If you have a physical card you must sign at the back of it as soon
                as you receive it for added security. A virtual card is a soft copy
                replica of a physical card in the M-PAiSA App that could be used to
                conduct online transactions using the card details imprinted on the
                card. Digital Mastercard enables you use the NFC technology embedded in
                the mobile device to tap your phone to make a payment at a NFC POS [note
                this service is currently available on NFC -enabled Android
                devices].</p>
            <p>Please choose the pickup location of Your physical Mastercard
                carefully when You make your application for one. If You later change
                Your preferred pick-up spot then You will be required to pay FJD5.00 as
                a courier charge before the Mastercard is released to You.</p>
            <p>The Mastercard will be available at the new location for collection
                within 3 weeks from the time of request.</p>
            <p><strong>1.4 Amendment to T&amp;Cs</strong></p>
            <p>In so far as reasonably possible, Vodafone Fiji will attempt to give
                notice prior to any amendment of the T&amp;Cs. However, Vodafone Fiji
                reserves the right to modify these T&amp;Cs at any time without advance
                notice.</p>
            <p>Except for changes to local M-PAiSA fees and charges and material
                changes to these T&amp;Cs which will be notified 30 days in advance of
                coming into effect, any other changes to these T&amp;Cs (including
                Mastercard charges) will be effective immediately upon posting on the
                Vodafone Fiji website and the M-PAiSA App, with an updated effective
                date. By accessing or using the M-PAiSA Mastercard after any changes
                have been made, You signify Your agreement on a prospective basis to the
                modified T&amp;Cs and all the changes. Be sure to visit the Vodafone
                website and/or log on to the M-PAiSA App periodically to ensure
                familiarity with the most current version of the T&amp;Cs.</p>
            <h1 id="defined-terms-and-interpretation">2 DEFINED TERMS AND
                INTERPRETATION</h1>
            <p><strong>2.1 Defined Terms</strong></p>
            <p><strong>ATM</strong> means Automated Teller Machine</p>
            <p><strong>EFTPOS</strong> means electronic funds transfer at point of
                sale and the electronic equipment and software for use with the M-PAiSA
                Mastercard and PIN to conduct an EFTPOS Transaction</p>
            <p><strong>EFTPOS Transaction</strong> refers to an EFTPOS transaction
                initiated by You using Your M-PAiSA Mastercard and PIN</p>
            <p><strong>E Value</strong> means the electronic value recorded in a
                M-PAiSA Account, such electronic value representing Your entitlement to
                the cash amounts held by Vodafone Fiji for You</p>
            <p><strong>FJD</strong> refers to Fiji dollar</p>
            <p><strong>Law</strong> means any law, legislation, regulation, official
                directive, regulatory policy or lawful requirement and order in the
                Republic of Fiji.</p>
            <p><strong>Mastercard CVC</strong> means Card Verification Code
                necessary to conduct contactless transactions and can be found displayed
                at the back of the M-PAiSA Mastercard.</p>
            <p><strong>M-PAiSA Account/wallet</strong> refers to Your designated
                account containing Your entitlement to E Value.</p>
            <p><strong>M-PAiSA App</strong> refers to the mobile based application
                running on smart phones/mobile devices where customers of M-PAiSA
                Services can access the M-PAiSA Services.</p>
            <p><strong>M-PAiSA Mastercard</strong> refers to either physical and/or
                virtual debit card, issued to You by Vodafone Fiji under license with
                Mastercard Asia/Pacific Pte Limited linked to Your M-PAiSA
                Account/wallet.</p>
            <p><strong>M-PAiSA Mastercard Fees</strong> refers to the fees and other
                charges payable by You under these T&amp;Cs for issuance of and use of
                the M-PAiSA Mastercard.</p>
            <p><strong>M-PAiSA Services</strong> refers to the “Smart Wallet” mobile
                based solution – the payment services enabled by Vodafone Fiji.</p>
            <p><strong>OTP</strong> refers to one-time password-an automatically
                generated numeric string of characters that authenticates a user for a
                transaction, the OTP will be received by user by SMS or email</p>
            <p><strong>PIN</strong> is a ‘personal identification number’ being a
                4-digit number chosen by you that allows access to your Mastercard and
                associated M-PAiSA Account</p>
            <p><strong>SMS</strong> means a short message service consisting of a
                text message</p>
            <p><strong>Vodafone Fiji Customer Care helpline</strong> refers to
                access to Vodafone Fiji’s customer care by calling 124 (toll-free)
                (prepay), 125 (toll-free) (postpay),</p>
            <p>123 (charged line) or +679 9902123 if calling from overseas (charged
                line)</p>
            <p><strong>Vodafone Fiji website</strong> refers to the Vodafone Fiji
                website <a href="http://www.vodafone.com.fj/">www.vodafone.com.fj</a></p>
            <p><strong>You</strong> or <strong>Your</strong> refers to You, the
                person who has been issued with a M-PAiSA Mastercard</p>
            <p><strong>2.2 Interpretation</strong></p>
            <p>Headings are used for convenience and ease of reference only and are
                not to be considered in the interpretation or construction of any
                provision of these T&amp;Cs.</p>
            <p>3. BASIC TERMS</p>
            <p><strong>3.1 Mastercard for Your M-PAiSA Account</strong></p>
            <p>Mastercard issued to You will be linked to Your M-PAiSA Account. Only
                one MasterCard shall be issued to one M-PAiSA customer. Supplementary/
                multiple cards will not be issued on the same M-PAiSA Account or to the
                same M-PAiSA customer even if you have multiple M-PAiSA accounts.</p>
            <p><strong>3.2 What to use Your M-PAiSA Mastercard
                for?</strong></p>
            <p>M-PAiSA Mastercard can be used to access funds in Your M-PAiSA
                Account 24 hours a day, 7 days a week, to pay for goods and services,
                locally, overseas or online wherever Mastercard is an accepted form of
                payment:</p>
            <table>
                <colgroup>
                    <col style={{ width: "42%" }} />
                    <col style={{ width: "57%" }} />
                </colgroup>
                <thead>
                    <tr className="header">
                        <th colSpan="2"><strong>Purchase Goods or Services</strong></th>
                    </tr>
                </thead>
                <tbody>
                    <tr className="odd">
                        <td><p>EFTPOS in</p><p>Fiji</p></td>
                        <td>By either inserting, swiping or tapping the physical M-PAiSA
                            Mastercard and entering your PIN at the EFTPOS or tapping phone to pay
                            using the digital Mastercard (NFC enabled Android devices only)</td>
                    </tr>
                    <tr className="even">
                        <td><p>EFTPOS</p><p>outside of Fiji</p></td>
                        <td>By either inserting, swiping or tapping the M-PAiSA Mastercard and
                            entering Your PIN (if required) at the EFTPOS or tapping your phone to
                            pay using the digital Mastercard (NFC enabled Android devices only)</td>
                    </tr>
                    <tr className="odd">
                        <td>Internet (online transaction)</td>
                        <td>By entering the Mastercard number, customer name, Mastercard expiry
                            date and if required, the Mastercard CVC.</td>
                    </tr>
                    <tr className="even">
                        <td colSpan="2"><strong>Withdraw Cash</strong></td>
                    </tr>
                    <tr className="odd">
                        <td>Using ATMs where the Mastercard logo is displayed</td>
                        <td>By selecting the "savings" button and entering Your PIN.</td>
                    </tr>
                </tbody>
            </table>
            <p>M-PAiSA Mastercard may be used for various financial transactions and
                payments. However, it is not meant to be used for business import,
                business service payment, transfer of capital outside of Fiji or other
                similar types of business or personal transactions.</p>
            <h2 className="unnumbered" id="transaction-limits">3.3 Transaction
                Limits</h2>
            <p>Currently
                the limit on E-Value allowed to be kept in a M-PAiSA wallet is set at
                FJD 5,000 or FJD10,000 depending on your level of KYC compliance based
                on your ID documentation and information on your source of funds. The
                use of your M-PAiSA Mastercard to pay for goods and services outside of
                Fiji is considered an overseas remittance and is subject to limits and
                controls as set or revised by the Reserve Bank of Fiji and/or in
                accordance with exchange control Laws. As currently set, the use of
                M-PAiSA Mastercard for remittances, purchases and payments overseas must
                not exceed FJD 5000.00 in a month (for non-import payment without Tax
                Clearance Certificate). For the latest overseas payment limit on your
                Mastercard visit: Exchange Control Guidelines - Reserve Bank of Fiji
                (rbf.gov.fj) The limits currently set are subject to regulatory changes.
                Changes if any could be effective immediately.</p>
            <h2 id="use-of-pin">3.4 Use of PIN</h2>
            <p>Your Mastercard PIN is the same as your 4-digit M-PAiSA Account/App
                PIN as set or updated by you from time to time.</p>
            <h2 id="pin-and-m-paisa-mastercard-security">3.5 PIN and M-PAiSA Mastercard
                Security</h2>
            <p>You are personally responsible to prevent unauthorised transactions
                on your M-PAiSA Account using the M-PAiSA Mastercard. Therefore, you
                must not disclose Your PIN or give your M-PAiSA Mastercard to anyone
                including Your family, friends, persons who claim to be employees of
                Vodafone Fiji or, anyone who appears to be in authority. You must do
                everything You can and take all reasonable precautions to keep the card
                and PIN secure, private and confidential. You must memorize Your PIN and
                not ever write it down anywhere. When using Your PIN take reasonable
                care to avoid others seeing it by physically hiding its entry.</p>
            <p>Whether you are issued your first Mastercard or it is a replacement
                for a lost or stolen card, it is recommended you set a new PIN or;
                update your PIN for use with M-PAiSA Mastercard and M-PAiSA App from
                time-to- time.</p>
            <h2 id="one-time-pin-otp">3.6 One-Time PIN (OTP)</h2>
            <p >Certain
                transactions made with your M-PAiSA Mastercard may require entry of a
                One-Time Password (OTP). The OTP will be sent via SMS to the mobile
                number linked to your M-PAiSA Account/wallet or to your registered email
                address. Entering the OTP to complete the transaction serves as
                confirmation that the transaction has been duly approved and authorized
                by the rightful account holder. Restrictions on use of M-PAiSA
                Mastercard</p>
            <p>M-PAiSA Mastercard must be utilized strictly in accordance with these
                T&amp;Cs. It must not be used for any unlawful purpose for example, to
                conduct money laundering, commit a crime, to perform an act which is
                negligent, which would attract civil liability or, be in breach of any
                Laws and/or these T&amp;Cs. At all times you will be personally
                responsible for transactions conducted with your M-PAiSA Mastercard
                therefore you must keep it safe and secure and in your personal
                possession.</p>
            <h2 id="property-of-the-m-paisa-mastercard">3.7 Property of the M-PAiSA
                Mastercard</h2>
            <p>Any M-PAiSA Mastercard issued remains the sole property of, or under
                license to Vodafone Fiji and is non- transferable. Vodafone Fiji may
                suspend or terminate the use of the M-PAiSA Mastercard for whatever
                reason it deems fit including but not limited to if Your M-PAiSA Account
                is closed or suspended.</p>
            <p><strong>3.8 Surrender of M-PAiSA Mastercard</strong></p>
            <p>You agree to surrender the M-PAiSA Mastercard upon demand by Vodafone
                Fiji. In the event of any suspension, termination or confiscation of the
                M-PAiSA Mastercard, You agree to hold Vodafone Fiji and its affiliates,
                its board of directors, officers and employees free and harmless from
                any claim, damage, loss, expense, suit or liability whatsoever, arising
                from such suspension, termination or confiscation.</p>
            <p><strong>3.9 Suspension</strong></p>
            <p>On a case by case basis, Vodafone Fiji may opt to suspend or
                terminate Your privilege to use a particular feature, whenever it deems
                appropriate and necessary, particularly, but not limited to occasions
                when there is suspicion of money laundering and terrorist financing
                activities or confirmation of fraudulent, unauthorised or other unlawful
                transactions. Vodafone Fiji will charge a fee upon reactivation of the
                said features at Your request. The approval of the request shall be at
                the sole discretion of Vodafone Fiji.</p>
            <p><strong>3.10 Care with M-PAiSA Mastercard</strong></p>
            <p>In the event of any unauthorised use/transactions on Your M-PAiSA
                Mastercard, You will not be held responsible if: You kept secure and
                protected Your PIN from disclosure to a third party, used reasonable
                care in protecting Your card from loss or theft; AND You promptly
                reported loss or theft to Vodafone Fiji.</p>
            <p><strong>3.11 Diligence with Automatic Subscriptions</strong></p>
            <p>Please note many online merchants offer free trial for their service
                for a limited time if you subscribe and provide your payment cards
                details. In such cases, any deduction of payment from your M-PAiSA
                Mastercard after the free trial period is deemed duly authorized by you
                for accepting the merchant conditions and there shall be no
                reimbursement.</p>
            <p>You must immediately unsubscribe from the said service or
                subscription to avoid any further payment deductions.</p>
            <h2 className="unnumbered" id="m-paisa-mastercard-security">3.12 M-PAiSA
                Mastercard Security</h2>
            <p>You will be responsible for the security, keep and proper care of the
                M-PAiSA Mastercard.</p>
            <h2 id="losstheft-of-m-paisa-mastercard">3.13 Loss/Theft of M-PAiSA
                Mastercard</h2>
            <p>In case of loss or theft of your M-PAiSA Mastercard, You must
                immediately inform Vodafone Fiji through any of the contact mechanisms
                detailed in these T&amp;C’s or, at any Vodafone Fiji retail outlet of
                such loss/theft within</p>
            <p>24 hours. Alternatively, promptly use the “Stop Physical Card”
                feature on the M-PAiSA App to disable the “Physical” M-PAiSA Mastercard
                immediately and contact Vodafone Fiji Customer Care helpline to report
                the loss/theft.</p>
            <h2 id="replacement-of-m-paisa-mastercard">3.14 Replacement of M-PAiSA
                Mastercard</h2>
            <p>A replacement M-PAiSA Mastercard may be created at Your cost (refer
                to M-PAiSA Mastercard Fees table online:<a href="http://www.vodafone.com.fj/personal/">https://www.vodafone.com.fj/personal/products-services/m-paisa/m-paisa-mastercard</a></p>
            <h2 id="terminationcancellation-of-the-m-paisa-mastercard">3.15 Termination/Cancellation
                of the M-PAiSA Mastercard</h2>
            <p>Should You fail to comply with these T&amp;Cs, your right to use the
                M-PAiSA Mastercard shall be terminated without notice.</p>
            <h2 id="remoteoff-site-purchases">3.16 Remote/Off-Site Purchases</h2>
            <p>For online/internet purchases, diligence is expected of You to only
                transact with reputable web merchants.</p>
            <p>Once the transaction has been authorized, You bind yourself with a
                merchant’s terms of sale such as but not limited to how You will receive
                the goods and/or services that You purchased.</p>
            <p>You shall be fully accountable for your payment transactions
                especially but not limited to in relation to web merchants that have
                limited or no refund policy.</p>
            <h1 className="unnumbered" id="section-1"></h1>
            <h1 id="m-paisa-mastercard-fees"><strong>4 M-PAiSA MASTERCARD
                FEES</strong></h1>
            <p>4.1 You agree that all fees and charges payable by You in connection
                with the use of the M-PAiSA Mastercard may be debited from Your M-PAiSA
                Account without further reference to or approval from You. The M-PAiSA
                Mastercard Fees may be revised and such changes will be advised to You
                30 days in advance of amendment except changes to any scheme fees by
                Mastercard will be effective immediately.For current Mastercard fees and
                charges visit: <a href="http://www.vodafone.com.fj/personal/products-services/m-paisa/m-paisa-mastercard">www.vodafone.com.fj/personal/products-services/m-paisa/m-paisa-mastercard</a></p>
            <p>4.2 To ensure uninterrupted M-PAiSA Mastercard service, a minimum
                credit balance of FJD2.00 must be maintained in your M-PAiSA account at
                all times. In the event that no funds are available on the billing date,
                the monthly fee will be deducted as soon as funds are deposited into the
                account. M-PAiSA Mastercard accounts with outstanding monthly access fee
                for period exceeding 3 months will be automatically placed on “hold”
                until the fee is paid in full. A pop-up notification will appear in the
                Mastercard tab of the M-PAiSA App for customers whose Mastercard
                accounts have been suspended due to unpaid fees. Customers must settle
                all outstanding monthly fees before they can resume conducting
                Mastercard transactions. Customers are encouraged to update to the
                latest version of the M-PAiSA app to ensure full accessibility to all
                features, including latest cybersecurity updates and suspension
                notifications.</p>
            <h1 id="overdrawn-accounts-and-recovery-rights"><strong>5 OVERDRAWN
                ACCOUNTS AND RECOVERY RIGHTS</strong></h1>
            <p><strong>5.1 Account Balance Requirements</strong> Your M-PAiSA
                Account must maintain a positive (credit) balance at all times, with a
                minimum credit balance of FJD2.00 to ensure uninterrupted M-PAiSA
                Mastercard service (as noted in the M-PAiSA Mastercard Fees section).
                Additionally, You are solely responsible for ensuring sufficient funds
                (E-Value) are available in your M-PAiSA Account prior to any transaction
                or when providing your M-PAiSA Mastercard details as security or for
                pre-authorization. Negative balances are not permitted under normal
                circumstances, and you agree not to initiate or permit transactions that
                would cause an overdrawn (negative) account.</p>
            <p><strong>5.2 Exceptions Due to Mastercard Obligations </strong>
                Notwithstanding the positive balance requirement, in certain scenarios
                where your M-PAiSA Mastercard details are provided as security or for
                pre-authorization (such as hotel stays, car rentals, or similar
                services), a merchant may process a delayed, retrospective, amended, or
                final charge after an initial authorization or hold. If we are required
                to honor such a charge under Mastercard rules, network obligations,
                merchant agreements, or applicable Law, even if your M-PAiSA Account
                lacks sufficient funds at the time of final processing, this may result
                in your account becoming overdrawn (negative balance).</p>
            <p><strong>5.3 Your Liability for Overdrawn Balances</strong> You
                acknowledge and agree that any negative balance arising from such
                transactions (or any other authorized charges) is your personal debt
                owed to Vodafone Fiji. You are fully liable for the full overdrawn
                amount, plus any associated fees, interest (if applicable), or charges
                as detailed in these T&amp;Cs or our fee schedule. This liability arises
                directly from your use of the M-PAiSA Mastercard and the incurred
                expenses or charges.</p>
            <p><strong>5.4 Recovery Rights</strong> Vodafone Fiji reserves the
                unrestricted right to recover any overdrawn (negative) balance using any
                lawful methods, including without limitation:</p>

            <p>- Automatically deducting or offsetting the amount from any
                subsequent deposits, incoming transfers, credits, refunds, E-Value
                loads, or other funds added to your M-PAiSA Account;</p>
            <p>- Applying offsets against any other accounts, funds, or assets you
                hold with Vodafone Fiji or our affiliates;</p>
            <p>- Pursuing legal action, or other enforcement measures to recover the
                debt;</p>
            <p>- Suspending, restricting, blocking, or terminating your M-PAiSA
                Account, M-PAiSA Mastercard privileges, or related services until the
                negative balance is fully repaid;</p>
            <p>- Reporting the overdue debt to credit bureaus or relevant
                authorities, where permitted by Law.</p>
            <p><strong>5.5 Repayment Obligation</strong> You must repay any
                overdrawn balance immediately upon our notification or upon your
                awareness of the negative balance. Failure to repay may result
                in:</p>
            <p>- Additional fees (e.g., overdraft, recovery, or collection fees per
                our current fee schedule);</p>
            <p>- Interest accrual on the outstanding amount at a rate as
                notified;</p>
            <p>- Further restrictions on account usage, loading E-Value, or
                transacting.</p>
            <p><strong>5.6 Notification and Disputes</strong> We may notify you of
                any overdrawn balance via SMS to the contact mobile number linked to
                your M-PAiSA Account, email, the M-PAiSA App, or other available
                channels. You must monitor your account regularly via the M-PAiSA App or
                Transaction History. If you dispute a charge as unauthorized or
                erroneous, notify us within 7 days of the transaction date. Disputes do
                not suspend your obligation to repay the overdrawn amount pending
                resolution. Disputed transactions shall only be credited back once
                properly processed and proven in your favor by Vodafone Fiji.</p>
            <p><strong>5.7 Risk Acknowledgment</strong> By applying for, activating,
                or using your M-PAiSA Mastercard (including providing card details to
                merchants for security or pre-authorization), you acknowledge the risk
                of overdrawn balances in scenarios like delayed hotel billing or similar
                charges. You consent to these recovery provisions and agree to take
                reasonable steps (e.g., updating merchant details or monitoring holds)
                to minimize such risks.</p>
            <h1 className="unnumbered" id="section-2"></h1>
            <h1 id="limits-on-liability">6 LIMITS ON LIABILITY</h1>

            <p>6.1 Vodafone Fiji makes no warranty, express or implied, regarding
                M-PAiSA Services and or M-PAiSA Mastercard.</p>

            <p>The M-PAiSA Service and the M-PAiSA Mastercard is offered on an “AS
                IS”, “AS AVAILABLE” basis without warranties of any kind, other than
                warranties that are incapable of exclusion, waiver or limitation under
                the Laws applicable to these T&amp;Cs. Without limiting the generality
                of the foregoing, Vodafone Fiji makes no warranty: (1) as to the
                content, quality or accuracy of data or information provided, received
                or transmitted using the M-PAiSA Services or M-PAiSA Mastercard; (2) as
                to any service or product obtained using the M-PAiSA Services or M-PAiSA
                Mastercard; (3) that the M-PAiSA Services or operation of M-PAiSA
                Mastercard will be uninterrupted or error-free; or (4) that any
                particular result or information will be obtained.</p>
            <p>6.2 Vodafone Fiji shall not be liable for any loss, cost,
                compensation, damage or liability to You or a third party arising from,
                directly or indirectly, or as a result of any or all of the
                following:</p>

            <ol type="a">
                <li><p>loss or theft of Mastercard or unauthorised use and transactions
                    on Your M-PAiSA Account/wallet or M-PAiSA Mastercard by persons to whom
                    you willingly allowed access to details including the PIN of your
                    M-PAiSA Account/wallet and Mastercard;</p></li>
                <li><p>refusal of Vodafone Fiji, any licensed financial
                    institution/service provider, ATM or merchant establishment and the
                    like, whether local or overseas, to allow, accept or honor M-PAiSA
                    Mastercard;</p></li>
                <li><p>M-PAiSA Mastercard is honored by any bank, financial institution,
                    ATM or merchant establishment; however, payment transaction is not
                    authorized, for any reason whatsoever;</p></li>
                <li><p>You are unable to perform or complete any transaction through the
                    use of M-PAiSA Mastercard due to service/ system/ line
                    unavailability;</p></li>
                <li><p>any delay, interruption or termination of the M-PAiSA transaction
                    whether caused by administrative error, technical, mechanical,
                    electrical or electronic fault or difficulty or any other reason or
                    circumstance beyond Vodafone Fiji’s control (including but not limited
                    to acts of God, strike, labor disputes, civil unrest, wars, fire,
                    disturbance, action of government, health pandemic, atmospheric
                    conditions, lightning, interference or damage by third parties or any
                    change in legislation);</p></li>
                <li><p>unauthorised transactions on Your Mastercard unless You used
                    reasonable care to protect Your card from loss or theft and kept Your
                    PIN and other relevant details of Your M-PAiSA Account/wallet only to
                    Yourself and promptly reported the loss, theft or unauthorised use to
                    Vodafone Fiji.;</p></li>
                <li><p>for any transactions undertaken by You utilizing Mastercard
                    including but not limited to for pre-authorizations, undelivered goods
                    and services, defects, damages and after-sales services in relation to
                    such goods and /or services;</p></li>
                <li><p>any misrepresentation or misconduct of any third party in
                    relation to transactions on Mastercard conducted by You.</p></li>
            </ol>
            <p>6.3 NOTWITHSTANDING ANY OTHER PROVISION TO THE CONTRARY SET FORTH IN
                THESE T&amp;Cs, IN NO EVENT SHALL VODAFONE FIJI BE LIABLE UNDER ANY
                LEGAL THEORY, TORT, CONTRACT, OR STRICT LIABILITY, FOR ANY SPECIAL,
                INDIRECT, INCIDENTAL, CONSEQUENTIAL, PUNITIVE OR EXEMPLARY DAMAGES, FOR
                LOSS OF PROFITS, GOODWILL, OR ECONOMIC LOSS.</p>
            <p>6.4 EXCEPT AS SPECIFICALLY DESCRIBED HEREIN, VODAFONE FIJI MAKES NO
                WARRANTIES, EXPRESS OR IMPLIED, CONCERNING M-PAiSA MASTERCARD AND THE
                RELATED SERVICES AND WITHOUT LIMITATION, VODAFONE FIJI HEREBY EXCLUDES
                AND DISCLAIMS ALL EXPRESS OR IMPLIED WARRANTIES AND CONDITIONS TO THE
                EXTENT PERMITTED BY LAW, INCLUDING BUT NOT LIMITED TO, ANY IMPLIED
                WARRANTY OF MERCHANTABILITY, COURSE OF DEALING, NON-INFRINGEMENT OR
                FITNESS FOR A PARTICULAR PURPOSE.</p>
            <h1 className="unnumbered" id="section-3"></h1>
            <h1 id="fraudulent-transactions">7 FRAUDULENT TRANSACTIONS</h1>
            <h2 className="unnumbered" id="blocked-m-paisa-account-or-m-paisa-mastercard">7.1 Blocked M-PAiSA
                Account or M-PAiSA Mastercard</h2>
            <p>Vodafone Fiji shall have the right to automatically suspend or block
                the M-PAiSA Mastercard in the event that Vodafone Fiji has reason to
                believe that the M-PAiSA Account/M-PAiSA Mastercard may be used for
                money laundering and terrorist financing activities, fraudulent or
                suspicious transactions or by an unauthorized person or, if You are
                required by Law to submit any information and have failed to do so.
                Vodafone Fiji may but shall not have the obligation to inform You prior
                to suspending or blocking the M-PAiSA Mastercard pursuant to this
                section. You acknowledge the authority of Vodafone Fiji to suspend or
                block the M-PAiSA Mastercard and accordingly, You shall hold Vodafone
                Fiji free and harmless against any and all consequences of such
                suspension or blocking, or any loss or damage which You may suffer as a
                result thereof.</p>
            <h2 id="discretion">7.2 Discretion</h2>
            <p>Upon giving prior notice in so far as reasonably possible but without
                prejudice to the other provisions hereof, Vodafone Fiji has the absolute
                discretion to (a) refuse to approve any M-PAiSA transaction even if
                there is sufficient available balance; (b) suspend, terminate or cancel
                Your right to use the M-PAiSA Mastercard;</p>
            <p>(c)increase or decrease the transaction amount limit;</p>
            <p>(d) refuse to re-issue, renew or replace the M-PAiSA Mastercard
                and/or (e) introduce, amend, vary, restrict, terminate or withdraw the
                benefits, services, facilities and privileges with respect to or in
                connection with the M-PAiSA Mastercard, whether specifically relating to
                You due to breach of or suspected breach of T&amp;Cs and/or Laws or
                generally to all or specific M-PAiSA customers.</p>
            <h1 id="transaction-history">8 TRANSACTION HISTORY</h1>
            <h2 id="m-paisa-accounttransaction-history">8.1 M-PAiSA Account/Transaction
                History</h2>
            <p>M-PAiSA Account/Transaction history statement will be available on
                the M-PAiSA App. Vodafone Fiji shall be held free and harmless from any
                and all liability should the M-PAiSA Account/ Transaction history
                statement be disclosed to any person other than You. In all instances,
                You may inquire about the M-PAiSA Account/Transaction history statement
                by contacting the Vodafone Fiji Customer Care Helpline or by visiting
                any Vodafone Fiji retail store. Vodafone Fiji may charge a fee for
                M-PAiSA Account/Transaction history statement fee per request.</p>
            <h2 id="disputes-and-erroneous-transactions">8.2 Disputes and Erroneous
                Transactions</h2>
            <p>The details in the SMS message after every transaction and/or the
                entries in the M-PAiSA Account/Transaction History statement are
                presumed true and correct unless You notify Vodafone Fiji by way of
                email to: <a href="mailto:info@vodafone.com.fj">info@vodafone.com.fj</a>
                (Vodafone Customer),</p>
            <p><a href="mailto:info@inkk.com.fj">info@inkk.com.fj</a> (Inkk
                Customer) of any disputes within 15 days from the date of transaction.
                If no dispute is reported within the said period, all transactions and
                the entries in the M-PAiSA Account/Transaction History statement are
                considered conclusively true and correct. Disputed transactions shall
                only be credited back to Your M-PAiSA Account once the claim/ dispute
                has been properly processed, investigated, and proven by Vodafone and
                Mastercard to be in favour of You. On the other hand, there shall be no
                reversals for erroneous transactions made by You, in such cases you must
                personally liaise with the relevant merchant and You will be responsible
                for the outcome.</p>
            <h2 id="resolution-of-disputed-transaction">8.3 Resolution of Disputed
                Transaction</h2>
            <p>It must be noted that M-PAiSA Mastercard is part of the Global Scheme
                Card Payment network. Hence, payment made through this network to
                merchants locally or outside of Fiji including withdrawals using other
                bank ATM’s that may result in any disputed transaction, is subject to
                Mastercard’s international dispute resolution process and procedure.</p>
            <p>The timelines for resolution and/or final decision on any such
                disputed transaction may take up to 45 to 60 days.</p>
            <h1 id="data-sharing">9 DATA SHARING</h1>
            <p>By applying for M-PAiSA Mastercard and continuing to transact using
                it You hereby consent to and authorize Vodafone Fiji, its licensors,
                and/or its third party partners for the purposes including but not
                limited to fraud and risk management, sales and marketing activities,
                communications relating to its products and/or services, product and
                system development and innovation, customer experience management and
                improvement, and market research, and the statutory regulator or any
                Government department or agency to collect and process any and all
                information related to the provision and utilisation of M-PAiSA
                Mastercard and related services. In addition, you hereby agree to share
                Your M-PAiSA information details, including but not limited to: complete
                name, gender, marital status, address (permanent and present), date and
                place ofbirth, nationality, contact details, nature of work,
                identification (with number) type, tax identification number, occupation
                and source of funds, to Vodafone Fiji’s remittance partners for purposes
                of service fulfilment and local and international anti-money laundering
                compliance requirements.</p>
            <p>The foregoing consents and authorizations shall continue for the
                duration of, and shall survive the termination of use of M-PAiSA
                Mastercard by You.</p>
            <h1 className="unnumbered" id="section-4"></h1>
            <h1 id="miscellaneous">10 MISCELLANEOUS</h1>
            <p>10.1These T&amp;Cs are governed by and subject to the laws of the
                Republic of Fiji.</p>

            <p>10.2 If a dispute arises in connection with these T&amp;Cs, either
                You or Vodafone Fiji may give written notice requiring that an attempt
                be made to resolve the dispute initially between You and a management
                team of Vodafone Fiji. If the dispute is unable to be resolved to the
                mutual satisfaction of the parties in such manner within 21 days of the
                notice of dispute then the dispute may be escalated to the Reserve Bank
                of Fiji to assist with resolution. If the dispute remains unresolved on
                the expiry of 3 months from the initial notice of dispute then unless
                otherwise agreed the dispute will be referred to a mediator to be
                appointed by the Reserve Bank of Fiji. Each of the parties must
                co-operate fully with the mediator and pay an equal share of the fees
                and expenses the mediator is entitled to. If the dispute is unable to be
                resolved before a mediator then it shall be referred to arbitration
                before an arbitrator selected by the President of the Fiji Institute of
                Accountants. The seat of arbitration shall be in Suva, Fiji and its cost
                shall be borne by the unsuccessful party. To the extent permissible by
                Law, the determination of the arbitrator shall be final, conclusive and
                binding upon the parties hereto.</p>
            <p>10.3 Vodafone Fiji will send notices to You via SMS to the contact
                mobile number linked to Your M-PAiSA Account.</p>

            <p>10.4 All formal notices required or authorised by this Agreement are
                to be in writing in the English language and are to be delivered by
                either party to the other by hand and/or by registered post and/or by
                email to such address as last notified to a party. Notices delivered by
                email will be deemed delivered immediately provided that the sender’s
                email computer software confirms that the message has been sent and the
                sender’s computer software does not receive a delivery failure
                notification in respect of such email. Notices delivered by hand will be
                deemed given upon hand delivery. Notices delivered by registered post
                will be deemed given on the seventh working day after the envelope
                containing the same was posted.</p>
            <p>10.5 You must not assign or transfer any of your rights and/or
                obligations under these T&amp;Cs or the M-PAiSA Conditions of Use.
                Vodafone Fiji may assign or transfer any of its rights and/or
                obligations under these T&amp;Cs or the M-PAiSA Conditions of Use.</p>
            <p>10.6 Neither party shall be liable for loss or damage or be deemed to
                be in default under these T&amp;Cs if its failure to perform its
                obligations results from or is attributable to any act of God, natural
                disaster, fire, strike, embargo, war, threat of terrorism, insurrection,
                strike, riot, health pandemic, Governmental directive or other cause or
                circumstance beyond the reasonable control of the party provided however
                that the foregoing shall not excuse any failure to exercise diligence by
                a party to minimize the scope, extent, duration and adverse effect of
                any such delay in performance, on the other party.</p>

            <p>10.7 The headings are included for convenience only and shall not
                affect the meaning or interpretation of these T&amp;Cs.</p>
            <p>10.8 All copyright, trademarks and other intellectual property rights
                used as part of the M-PAiSA Mastercard, the Mastercard brand or any
                customer data are exclusively owned or licensed by Vodafone Fiji, its
                affiliates or its licensors. You agree that You acquire no rights
                thereto.</p>
            <p>10.9 Failure, omission, or delay on the part of Vodafone Fiji to
                exercise its rights or remedies under these T&amp;Cs shall not operate
                as a waiver.</p>
            <p>10.10 Should any provision in these T&amp;Cs be rendered void, illegal
                or unenforceable in any respect under any Law, the validity, legality
                and enforceability of the remaining terms and conditions shall not be
                affected or impaired thereby.</p>

            <h1 id="customer-complaints-handling-process">11 CUSTOMER COMPLAINTS
                HANDLING PROCESS</h1>
            <p>Vodafone Fiji is committed to maintaining the highest standards of
                financial consumer protection.</p>
            <p>Your requests, feedback and customer needs are our priority. If You
                have any concerns about a procedure or have encountered a problem with
                Your M-PAiSA Mastercard, You may contact our Vodafone Customer Care
                Helpline available 24 hours a day, 7 days a week.</p>
            <p>Call us on <strong>123 (charged), 124 (Toll free)</strong> or email 
                <a href="mailto:info@vodafone.com.fj"><strong>info@vodafone.com.fj </strong></a>
                 or visit</p>
            <p><a href="http://www.vodafone.com.fj/personal/products-services/m-paisa/m-paisa-mastercard"><strong>www.vodafone.com.fj/personal/products-services/m-paisa/m-paisa-mastercard</strong></a></p>
        </div>

    )
}

export default MCTermsConditions;